import compileGeneralAdmission from './compilers/compileGeneralAdmission';

export default ({ GeneralAdmission }, { payload }) => {
    Object.entries(payload).forEach(([hash, usedCount]) => {
        const generalAdmission = GeneralAdmission.get({ hash });
        if (generalAdmission) {
            generalAdmission.seatsUsed += usedCount;
            if (generalAdmission.seatsUsed < 0) {
                generalAdmission.seatsUsed = 0;
            }
            compileGeneralAdmission(generalAdmission);
        }
    });
};
